<template>
  <div>
    <PotensiMain
        :itemsFPotensi="itemsFPotensi"
        :itemsFDayaDukung="itemsFDayaDukung"
        :itemsFDayaDukungType="itemsFDayaDukungType"
        :itemsFSubArea="itemsFSubArea"
        :itemsFArea="itemsFArea"
        :itemsFSectorType="itemsFSectorType"
        :itemsFInfrastructureType="itemsFInfrastructureType"
        :itemsFKomoditiType="itemsFKomoditiType"
    ></PotensiMain>

    <v-card class="" elevation="0" >
      <YoutubeVideo
      ></YoutubeVideo>
    </v-card>

    <DayaDukungBanner
        :itemsFDayaDukung="itemsFDayaDukung"
        :itemsFDayaDukungType="itemsFDayaDukungType"
    ></DayaDukungBanner>
    <AppFooter></AppFooter>
  </div>
</template>

<script>
import PotensiMain from "@/components/public-potensi/PotensiMain.vue";
import DayaDukungBanner from "@/components/public-daya-dukung-banner/DayaDukungBanner.vue";
import AppFooter from "@/components/AppFooter.vue";
import FDayadukungService from "@/services/apiservices/f-dayadukung-service";
import FPotensiService from "@/services/apiservices/f-potensi-service";
import FInfrastructureTypeService from "@/services/apiservices/f-infrastructure-type-service";
import FKomoditiTypeService from "@/services/apiservices/f-komoditi-type-service";
import YoutubeVideo from "@/components/beranda/beranda/YoutubeVideo.vue";

export default {
  name: "Home",
  components: {YoutubeVideo, AppFooter, DayaDukungBanner, PotensiMain },
  data() {
    return {
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4",
      ],

      itemsFDayaDukung: [],
      itemsFDayaDukungType: [],
      itemsFPotensi: [],

      itemsFSubArea: [],
      itemsFArea: [],
      itemsFSectorType: [],

      itemsFInfrastructureType: [],
      itemsFKomoditiType: [],
    };
  },
  computed: {
    lang: {
      get() {
        return this.$store.state.langModule.lang;
      },
      set(val) {
        this.$store.dispatch("langModule/setLang", val);
      },
    },
  },
  methods: {
    fetchFInfrastructureTypeForMap() {
      FInfrastructureTypeService.getAllFInfrastructureTypePublic()
          .then((response) => {
            this.itemsFInfrastructureType = response.data;
          })
          .catch((e) => {
            console.log(e);
          });
    },
    fetchFKomoditiTypeForMap() {
      FKomoditiTypeService.getAllFKomoditiTypePublic()
          .then((response) => {
            this.itemsFKomoditiType = response.data;
          })
          .catch((e) => {
            console.log(e);
          });
    },

    fetchFDayaDukungForMap() {
      FDayadukungService.getAllFDayaDukungWithParentPublic()
          .then((response) => {
            const { items, fDayaDukungTypes } = response.data;
            this.itemsFDayaDukung = items.map((item) => {
              item.fdayaDukungType = fDayaDukungTypes.find(
                  (fDayaDukungType) =>
                      fDayaDukungType.id === item.fdayaDukungTypeBean
              );
              return item;
            });
            this.itemsFDayaDukungType = fDayaDukungTypes;
          })
          .catch((e) => {
            console.log(e);
          });
    },
    fetchFPotensiForMap() {
      this.$store.dispatch("potensi/updateItemsFPotensiMarker", []);
      FPotensiService.getAllFPotensiWithParentPublic()
          .then((response) => {
            const { items, listFSubArea, listFArea, listFSectorType } =
                response.data;
            this.$store.dispatch("potensi/updateItemsFPotensiMarker", items);
            this.itemsFPotensi = items;
            this.itemsFSubArea = listFSubArea;
            this.itemsFArea = listFArea;
            this.itemsFSectorType = listFSectorType;
          })
          .catch((e) => {
            console.log(e);
          });
    },
  },
  mounted() {

    this.fetchFDayaDukungForMap();
    this.fetchFPotensiForMap();

    this.fetchFInfrastructureTypeForMap();
    this.fetchFKomoditiTypeForMap();
  },
};
</script>

<style scoped>
</style>